export default __webpack_public_path__ + "static/media/layout-table-16.342ec595.svg";